import * as angular from 'angular';
import { Observable } from 'rxjs';

import { formatBytes } from '~/common/format.bytes.helper';
import { AppStore } from '~/types/main.types';
import { DataViewTypes } from '@mode/shared/contract-common';
import { DataViewFacade } from '@mode/switch-views/contract';
import { map, switchMap } from 'rxjs/operators';
import { routerSelector } from '~/reducers/selectors';

class ReportDetailsDatasetController implements angular.IOnInit {
  static $inject = ['RxStoreService', 'DataViewFacade'];

  queryExecutedBy$: Observable<string>;
  reportRunState$: Observable<{
    isVisible: boolean;
    dataset: any;
    executing;
    queryRun: any;
    datasetSizeBytes?: number;
    rowsCountMessage: string;
  }>;

  rowsCountVisible$: Observable<boolean>;
  datasetResult$: Observable<DataViewTypes.DatasetResult>;

  constructor(
    private rxStore: AppStore,
    private dataViewFacade: DataViewFacade
  ) {}

  $onInit(): void {
    const queryToken$ = this.rxStore
      .select(routerSelector)
      .pipe(map((routerState) => routerState && routerState.params && routerState.params['queryId']));

    this.datasetResult$ = queryToken$.pipe(
      switchMap((queryToken) => {
        return this.dataViewFacade.getDatasetResultByQueryNoEmpty(queryToken);
      })
    );

    this.rowsCountVisible$ = this.datasetResult$.pipe(
      map((datasetResult) => {
        return !!(datasetResult.queryRunToken && datasetResult.queryRunState === 'succeeded' && datasetResult.rowCount);
      })
    );

    this.queryExecutedBy$ = this.datasetResult$.pipe(map((datasetResult) => datasetResult.executedBy));
  }

  getFormattedBytes(bytes: number): string {
    if (bytes != null && !isNaN(bytes)) {
      return formatBytes(bytes);
    }
  }
}

export const ID = 'reportDetailsDataset';

export const reportDetailsDataset: angular.IComponentOptions = {
  template: `
    <div class="report-details">
      <div ng-if="(ctrl.rowsCountVisible$ | async:this)" class="report-query-header">
        <h5>
          <span class="metadata">Data returned by {{ctrl.queryExecutedBy$ | async:this}}
        </h5>
        <div class="dataset-links">
          <a
          download="download"
          ng-href="{{ (ctrl.datasetResult$ | async:this).csvUrl }}"
          class="btn-icon-text btn btn-default"
          ng-click="ctrl.download($event);$event.stopPropagation()"
          target="_self"
          aria-label="Export"
          uib-tooltip="Export"
          tooltip-append-to-body="true"
          tooltip-placement="top"
          tooltip-popup-delay="750"
          >
            <capra-icon icon="icon-export"></capra-icon>
            <span class="export-copy">Export</span>
          </a>
          <copy-dataset-button
            query-token="(ctrl.datasetResult$ | async:this).queryToken"
            rows-count="(ctrl.datasetResult$ | async:this).rowCount"
            dataset-size-bytes="(ctrl.datasetResult$ | async:this).bytes"
            csv-to-download="(ctrl.datasetResult$ | async:this).csvUrl"
            json-to-copy="(ctrl.datasetResult$ | async:this).jsonUrl"
            columns="(ctrl.datasetResult$ | async:this).metaColumns"
            oversized="(ctrl.reportRunState$ | async:this).oversized"
            error="ctrl.flamingoError$ | async:this"
          ></copy-dataset-button>
        </div>
      </div>
      <report-query-result></report-query-result>
    </div>
  `,
  controller: ReportDetailsDatasetController,
  controllerAs: 'ctrl',
};
